module.exports = __webpack_public_path__ + "static/media/wk_180.10576344.svg";